module.exports = __webpack_public_path__ + "img/c05_buildingtechauxiliacampupgrade3_Normal_ua.cfc86cd6.webp";